package anjuros.development.sections

import androidx.compose.runtime.Composable
import anjuros.development.components.ReviewCard
import anjuros.development.components.SectionTitle
import anjuros.development.modules.Review
import anjuros.development.modules.Section
import anjuros.development.util.Constants
import anjuros.development.util.ReviewArrowStyle
import anjuros.development.util.ReviewCardMaxWidthStyle
import anjuros.development.util.ReviewSingleCardWidthStyle
import anjuros.development.util.SmallSectionWidthStyle
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronLeft
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronRight
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.browser.document
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun ReviewSection(){
    Box(
        modifier = Modifier
            .id(Section.Reviews.id)
            .fillMaxWidth()
            .maxHeight(600.px)
            .padding(topBottom = 70.px)
            .maxWidth(Constants.SECTION_WIDTH.px),
        contentAlignment = Alignment.Center
    ) {
        ReviewContent()
    }
}

@Composable
fun ReviewContent(){

    val breakPoint = rememberBreakpoint()
    val translateX=if(breakPoint> Breakpoint.MD) 375.0 else
       325.0
    Column(
        modifier = Modifier.fillMaxWidth(90.percent)
        ,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SectionTitle(
            modifier = SmallSectionWidthStyle.toModifier()
                .margin( bottom = 75.px),
            section = Section.Reviews,
            alignment = Alignment.CenterHorizontally
        )

        Row(modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically) {
            FaChevronLeft(
                modifier = ReviewArrowStyle.toModifier()
                    .align(Alignment.CenterVertically)
                    .cursor(Cursor.Pointer)
                    .onClick {
                        document.getElementById("scrollableContainer")
                            ?.scrollBy(x=-translateX, y=0.0)
                    },
                size = IconSize.XXL
            )
            Row(
                modifier = ReviewCardMaxWidthStyle.toModifier()
                    .id("scrollableContainer")
                    .fillMaxWidth()
                    .margin(bottom = 25.px)
                    .overflow(Overflow.Hidden)
                    .scrollBehavior(ScrollBehavior.Smooth)
            ) {

                Review.entries.forEach { review ->
                    ReviewCard(
                        modifier = ReviewSingleCardWidthStyle.toModifier().margin(right = if (review.ordinal == Review.entries.size - 1) 0.px else 25.px),
                        review
                    )

                }
            }
            FaChevronRight(
                modifier = ReviewArrowStyle.toModifier()
                    .align(Alignment.CenterVertically)
                    .cursor(Cursor.Pointer)
                    .onClick {
                        document.getElementById("scrollableContainer")
                            ?.scrollBy(x=translateX, y=0.0)
                    },
                size = IconSize.XXL
            )
        }
    }
}